import React, { useState, useCallback, ReactNode } from 'react';
import './SlideoutTabs.scss';

type SlideoutTabItemProps = {
  label: string;
  icon?: string;
  onClick?: (e: string) => any;
  isActive?: boolean;
};

const SlideoutTabItem = ({
  isActive,
  label,
  onClick,
  icon,
}: SlideoutTabItemProps) => {
  const onClickTab = useCallback(() => onClick && onClick(label), []);
  const className = `slideout-tabs__item ${
    isActive ? 'slideout-tabs__item--selected' : ''
  }`;

  return (
    <div className={className} onClick={onClickTab}>
      {icon && <i className={`fa ${icon}`} />}
      {label}
    </div>
  );
};

type SlideoutTabsProps = {
  defaultActiveKey?: string;
  onChange?: (e: string) => any;
  children: ReactNode;
};

type SlideoutTabItemChild = {
  props: SlideoutTabItemProps;
};

const SlideoutTabs = ({
  defaultActiveKey,
  children,
  onChange,
}: SlideoutTabsProps) => {
  const [activeTab, setActiveTab] = useState(
    defaultActiveKey || (children && (children[0].props.label as string)),
  );
  const onTabClicked = useCallback((tab: string) => {
    setActiveTab(tab);
    onChange && onChange(tab);
  }, []);

  return (
    <div className="slideout-tabs">
      <div className="slideout-tabs__items">
        {children &&
          Array.isArray(children) &&
          children.map((child: SlideoutTabItemChild) => {
            const { label, icon } = child.props;

            return (
              <SlideoutTabItem
                isActive={activeTab === label}
                key={label}
                label={label}
                icon={icon}
                onClick={onTabClicked}
              />
            );
          })}
      </div>
    </div>
  );
};

SlideoutTabs.Item = SlideoutTabItem;

export { SlideoutTabs };
